<template>
    <button
      class="relative overflow-hidden group bg-purple-600 hover:bg-purple-500 text-white font-medium px-4 py-2 rounded-xl transition duration-300 focus:outline-none focus:ring focus:ring-blue-400"
    >
      <span class="relative z-10">
        <slot></slot>
      </span>
      <!-- Gloss Effect -->
      <span
        class="absolute top-0 left-[-75%] w-[200%] h-full bg-gradient-to-r from-transparent via-white/30 to-transparent opacity-0 group-hover:opacity-100 transform skew-x-[-20deg] transition-all duration-700 group-hover:translate-x-[75%]"
      ></span>
    </button>
  </template>
  
  <script setup></script>
  
  <script>
  export default {
    name: 'PrimaryButton',
  }
  </script>
  